import React, { useEffect, useState, useRef } from "react";
import "./TableDetails.css";

const TableDetails = (props) => {
  const { table } = props
  const [answers, setAnswers] = useState([]);
  const [userAnswersOfStep2, setUserAnswersOfStep2] = useState({});
  const [showResultsofStep2, setShowResultsofStep2] = useState(false);
  const [scoreOfStep2, setScoreOfStep2] = useState(0);
  const [userAnswersOfStep3, setUserAnswersOfStep3] = useState({});
  const [showResultsofStep3, setShowResultsofStep3] = useState(false);
  const [scoreOfStep3, setScoreOfStep3] = useState(0);
  const [userAnswersOfStep4, setUserAnswersOfStep4] = useState({});
  const [showResultsofStep4, setShowResultsofStep4] = useState(false);
  const [scoreOfStep4, setScoreOfStep4] = useState(0);
  const [draggedAnswer, setDraggedAnswer] = useState(null);
  const [availableAnswers, setAvailableAnswers] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [mcqQuestions, setMcqQuestions] = useState([]);
  const [mcqScore, setMcqScore] = useState(0);
  const [showMcqResult, setShowMcqResult] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isAnswerChecked, setIsAnswerChecked] = useState(false);
  const [shuffledIndices, setShuffledIndices] = useState([]);
  let countIndex = useRef(0)

  // useEffect(() => {
  //   const newAnswers = Array.from({ length: 12 }, (_, i) => table * (i + 1));
  //   setAnswers(newAnswers);
  //   setAvailableAnswers([...newAnswers].sort(() => Math.random() - 0.5));
  //   generateMCQQuestions(newAnswers);
  // }, [table]);

  useEffect(() => {
    const newAnswers = Array.from({ length: 12 }, (_, i) => table * (i + 1));
    setAnswers(newAnswers);
    setAvailableAnswers([...newAnswers.slice(0, 10)].sort(() => Math.random() - 0.5));
    generateMCQQuestions(newAnswers);
  }, [table]);

  const generateWrongOptions = (correctAnswer) => {
    const options = new Set();
    options.add(correctAnswer);

    while (options.size < 4) {
      const wrongAnswer = correctAnswer + Math.floor(Math.random() * 10) - 5;
      if (wrongAnswer > 0 && wrongAnswer !== correctAnswer) {
        options.add(wrongAnswer);
      }
    }

    return [...options];
  };

  const generateMCQQuestions = (answers) => {
    const questions = answers.map((answer, index) => {
      const options = generateWrongOptions(answer);
      return {
        question: `${table} × ${index + 1} = ?`,
        options: options.sort(() => Math.random() - 0.5), // Shuffle options
        correctAnswer: answer,
        index: index + 1
      };
    });

    const shuffledQuestions = questions.sort(() => Math.random() - 0.5);
    setMcqQuestions(shuffledQuestions);
    console.info(shuffledQuestions)
  };

  const handleMcqAnswer = (selectedOption) => {
    setSelectedAnswer(selectedOption);
    setIsAnswerChecked(true);

    if (selectedOption === mcqQuestions[currentQuestionIndex].correctAnswer) {
      setMcqScore(prev => prev + 1);
    }
  };

  const goToNextQuestion = () => {
    if (currentQuestionIndex < mcqQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      countIndex.current = countIndex.current + 1;
      setSelectedAnswer(null);
      setIsAnswerChecked(false);
    } else {
      setShowMcqResult(true);
    }
  };

  const resetMcq = () => {
    setCurrentQuestionIndex(0);
    countIndex.current = 0;
    setMcqScore(0);
    setShowMcqResult(false);
    setSelectedAnswer(null);
    setIsAnswerChecked(false);

  };


  const handleDragStart = (answer, e) => {
    setDraggedAnswer(answer);
    e.target.classList.add('opacity-50');
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    setUserAnswersOfStep2(prev => ({
      ...prev,
      [index]: value
    }));
  };

  const handleInputChangeOfStep4 = (e, index) => {
    const { value } = e.target;
    setUserAnswersOfStep4(prev => ({
      ...prev,
      [index]: value
    }));
  };

  const handleDragEnd = (e) => {
    e.target.classList.remove('opacity-50');
  };

  const handleDrop = (index, e) => {
    e.preventDefault();
    if (draggedAnswer !== null) {
      setUserAnswersOfStep3(prev => ({
        ...prev,
        [index]: draggedAnswer
      }));
      setAvailableAnswers(prev => prev.filter(a => a !== draggedAnswer));
      setDraggedAnswer(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const getCorrectCount = (userAnswers) => {
    const correctCount = answers.reduce((count, answer, index) => {
      return count + (parseInt(userAnswers[index]) === answer ? 1 : 0);
    }, 0);
    return correctCount;
  }

  const checkAnswersforStep2 = () => {
    setScoreOfStep2(getCorrectCount(userAnswersOfStep2));
    setShowResultsofStep2(true);
  };

  const checkAnswersforStep3 = () => {
    setScoreOfStep3(getCorrectCount(userAnswersOfStep3));
    setShowResultsofStep3(true);
  };

  const checkAnswersforStep4 = () => {
    setScoreOfStep4(getCorrectCount(userAnswersOfStep4));
    setShowResultsofStep4(true);
  };


  const resetPractice = (action) => {
    setUserAnswersOfStep3({});
    setShowResultsofStep3(false);
    setScoreOfStep3(0);
    if (action === 'mcq') {
      setAvailableAnswers([...answers.slice(0, 10)].sort(() => Math.random() - 0.5));
    }

  };

  const resetPracticeForStep2 = () => {
    setUserAnswersOfStep2({});
    setShowResultsofStep2(false);
    setScoreOfStep2(0);
  };
  const resetPracticeForStep4 = () => {
    setUserAnswersOfStep4({});
    setShowResultsofStep4(false);
    setScoreOfStep4(0);
  };

  const shuffleArray = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  useEffect(() => {
    const indices = Array.from({ length: answers.length }, (_, i) => i);
    setShuffledIndices(shuffleArray(indices));
  }, [answers]);


  useEffect(() => {
    resetPracticeForStep2()
    resetPracticeForStep4()
    resetMcq()
    resetPractice()
  }, [table])

  return (
    <div className='card-body p-0 ck-content'>
      <h1>Practice the {table} Times Table</h1>
      <div className="p-4">
        <h2 className="text-xl mb-4">Step 1: Familiarize Yourself with the Table</h2>
        <p className="mb-4">Take a thorough look at the table to understand its structure and content.Read the table data out loud to reinforce your understanding and memory.
          Repeat viewing and reading aloud until you feel confident about remembering the information.Once you think you’ve memorized the table, proceed to Step 2 to test your knowledge!
        </p>
        <div className="bg-white p-4 rounded shadow">
          <h3 className="text-lg mb-2">{table} Times Table</h3>
          <ul className="space-y-2">
            {answers.map((answer, index) => (
              <li key={index} className="text-lg">
                {table} × {index + 1} = {answer}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Step 1b: Input Practice */}
      <div className="p-4">
        <h2 className="text-xl mb-4">Step 2: Practice in Sequence </h2>
        <p className="mb-4">Enter your answers in the correct order for the table. Click on the 'Check' button to see if your answers are accurate.
          Once you get all the answers right, challenge yourself by practicing the {table} times table in a random order.  </p>
        <div className="bg-white p-4 rounded shadow">
          <table className="w-full">
            <tbody>
              {answers.map((answer, index) => (
                <tr key={index} className="border-b">
                  <td className="py-2">{table} × {index + 1} = </td>
                  <td className="py-2">
                    <input
                      type="number"
                      value={userAnswersOfStep2[index] || ''}
                      onChange={(e) => handleInputChange(e, index)}
                      className="w-24 p-2 border rounded shadow"
                    />
                  </td>
                  {showResultsofStep2 && (
                    <td className="py-2 pl-4">
                      {parseInt(userAnswersOfStep2[index]) === answer ? (
                        <span className="text-green-500">✓ Correct!</span>
                      ) : (
                        <span className="text-red-500">✗ Answer: {answer}</span>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-4">
          <button
            onClick={checkAnswersforStep2}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Check Answers
          </button>
          <button
            onClick={resetPracticeForStep2}
            className="bg-gray-500 text-white px-6 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            style={{ marginLeft: '10px' }}
          >
            Reset
          </button>

          {showResultsofStep2 && (
            <div className="mt-4">
              <p className="text-lg font-semibold">
                Your Score: {scoreOfStep2} out of {answers.length}
              </p>
              {scoreOfStep2 === answers.length ? (
                <p className="text-green-500">Perfect score! Well done!</p>
              ) : (
                <p className="text-blue-500">Keep practicing to improve!</p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="p-1">
        <h2 className="text-xl font-bold mb-4">Step 3: Match the Correct Answer</h2>
        <p className="mb-4">
          Select the correct answer and drag it to match the corresponding question.Ensure each answer aligns with the correct question.
          Repeat the activity until you can confidently match all answers without hesitation.
        </p>
        <div className="">
          <div className="bg-white rounded-lg shadow drag-drop-div">
            <span className="col-md-8 col-xs-4">
              {answers.map((answer, index) => (
                index < 10 &&
                <div key={index} className="mt-1">
                  <span className="step-3-que-row">
                    <span className="col-md-2 text-lg w-32 step-3-que">{table} × {index + 1} = </span>
                    <div
                      onDrop={(e) => handleDrop(index, e)}
                      onDragOver={handleDragOver}
                      onTouchEnd={(e) => {
                        // Mobile touch handling
                        if (draggedAnswer) {
                          e.preventDefault();
                          setUserAnswersOfStep3(prev => ({
                            ...prev,
                            [index]: draggedAnswer
                          }));
                          setAvailableAnswers(prev => prev.filter(a => a !== draggedAnswer));
                          setDraggedAnswer(null);
                        }
                      }}
                      onClick={(e) => {
                        // Mobile tap handling
                        if (draggedAnswer) {
                          e.preventDefault();
                          setUserAnswersOfStep3(prev => ({
                            ...prev,
                            [index]: draggedAnswer
                          }));
                          setAvailableAnswers(prev => prev.filter(a => a !== draggedAnswer));
                          setDraggedAnswer(null);
                        }
                      }}
                      className={`dropBox w-32 h-12 flex items-center justify-center col-md-2`}
                    >
                      {userAnswersOfStep3[index] ? 
                        <button className="btn btn-primary">{userAnswersOfStep3[index]}</button> : 
                        <span className="bg-blue-100"></span>}
                    </div>
                  </span>
                  {showResultsofStep3 && (
                    <span className={`col-md-7 mt-2 ${parseInt(userAnswersOfStep3[index]) === answer
                      ? 'text-green-500'
                      : 'text-red-500'
                      }`}>
                      {parseInt(userAnswersOfStep3[index]) === answer
                        ? '✓ Correct!'
                        : `✗ Answer is: ${answer}`}
                    </span>
                  )}
                </div>
              ))}
            </span>
            <span className="drag-drop-right">
              {availableAnswers.map((answer) => (
                <button
                  key={answer}
                  draggable
                  onDragStart={(e) => handleDragStart(answer, e)}
                  onDragEnd={handleDragEnd}
                  onTouchStart={(e) => {
                    // Mobile touch handling
                    e.preventDefault();
                    setDraggedAnswer(answer);
                    e.target.classList.add('opacity-50');
                  }}
                  onTouchEnd={(e) => {
                    e.target.classList.remove('opacity-50');
                  }}
                  className="btn btn-success col-md-4 m-1"
                  style={{ width: '100px' }}
                >
                  {answer}
                </button>
              ))}
            </span>
          </div>

          {/* Rest of your buttons and result display */}
          <div className="mt-4 px-6">
            <button
              onClick={checkAnswersforStep3}
              className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              Check Answers
            </button>
            <button
              onClick={() => resetPractice('mcq')}
              className="bg-gray-500 text-white px-6 py-2 rounded-lg hover:bg-gray-600 transition-colors"
              style={{ marginLeft: '10px' }}
            >
              Reset
            </button>
          </div>

          {showResultsofStep3 && (
            <div className="bg-white p-4 rounded-lg shadow" style={{ marginTop: '20px' }}>
              <p className="text-lg font-semibold">
                Your Score: {scoreOfStep3} out of 10
              </p>
              {scoreOfStep3 === 10 ? (
                <p className="text-green-500 mt-2">Perfect score! Well done! 🎉</p>
              ) : (
                <p className="text-blue-500 mt-2">Keep practicing to improve! 💪</p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="p-4">
        <h2 className="text-xl mb-4">Step 4: Practice in Shuffled Order </h2>
        <p className="mb-4">Work on the {table} times table in a random, shuffled order.Complete all the answers based on the shuffled questions.
          Press 'Check' to review your accuracy and see how many answers you got right.
        </p>

        <div className="bg-white p-4 rounded shadow">
          <table className="w-full">
            <tbody>
              {shuffledIndices.map((shuffledIndex, index) => (
                <tr key={index} className="border-b">
                  <td className="py-2">{table} × {shuffledIndex + 1} = </td>
                  <td className="py-2">
                    <input
                      type="number"
                      value={userAnswersOfStep4[shuffledIndex] || ''}
                      onChange={(e) => handleInputChangeOfStep4(e, shuffledIndex)}
                      className="w-24 p-2 border rounded shadow"
                    />
                  </td>
                  {showResultsofStep4 && (
                    <td className="py-2 pl-4">
                      {parseInt(userAnswersOfStep4[shuffledIndex]) === answers[shuffledIndex] ? (
                        <span className="text-green-500">✓ Correct!</span>
                      ) : (
                        <span className="text-red-500">✗ Answer: {answers[shuffledIndex]}</span>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-4">
          <button
            onClick={checkAnswersforStep4}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Check Answers
          </button>
          <button
            onClick={resetPracticeForStep4}
            className="bg-gray-500 text-white px-6 py-2 rounded-lg hover:bg-gray-600 transition-colors"
            style={{ marginLeft: '10px' }}
          >
            Reset
          </button>

          {showResultsofStep4 && (
            <div className="mt-4">
              <p className="text-lg font-semibold">
                Your Score: {scoreOfStep4} out of {answers.length}
              </p>
              {scoreOfStep4 === answers.length ? (
                <p className="text-green-500">Perfect score! Well done!</p>
              ) : (
                <p className="text-blue-500">Keep practicing to improve!</p>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="p-4">
        <h2 className="text-xl font-bold mb-4">Step 5: Multiple Choice Practice</h2>
        <p className="mb-4"> Carefully read each question provided.Select the correct answer from the multiple-choice options.Submit your choice to see if it’s correct.
          Repeat the activity to strengthen your understanding and improve accuracy.
        </p>
        <div className="bg-white p-6 rounded-lg shadow">
          {!showMcqResult ? (
            <div>
              <div className="mb-4">
                <p className="text-sm text-gray-600">
                  Question {countIndex.current} of {mcqQuestions.length}
                </p>
                <h3 className="text-2xl font-bold mb-4">
                  {mcqQuestions[currentQuestionIndex]?.question}
                </h3>
              </div>

              <div className="grid grid-cols-2 gap-4">
                {mcqQuestions[currentQuestionIndex]?.options.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => !isAnswerChecked && handleMcqAnswer(option)}
                    className={`p-4 text-lg rounded-lg transition-colors ${isAnswerChecked
                        ? option === mcqQuestions[currentQuestionIndex].correctAnswer
                          ? 'bg-green-500 '  // Correct answer turns green
                          : option === selectedAnswer ? 'bg-red-500' : 'bg-blue-100'  // Incorrect answer turns red
                        : 'bg-blue-100'
                      }`}
                    disabled={isAnswerChecked}
                  >
                    {option}
                  </button>
                ))}
              </div>

              {isAnswerChecked && (
                <div className="mt-6">
                  <p className={selectedAnswer === mcqQuestions[currentQuestionIndex].correctAnswer
                    ? "text-green-500 font-bold"
                    : "text-red-500 font-bold"}>
                    {selectedAnswer === mcqQuestions[currentQuestionIndex].correctAnswer
                      ? "Correct! Well done!"
                      : `Incorrect. The right answer is ${mcqQuestions[currentQuestionIndex].correctAnswer}`}
                  </p>
                  <button
                    onClick={goToNextQuestion}
                    className="mt-4 bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
                  >
                    {currentQuestionIndex < mcqQuestions.length - 1 ? "Next Question" : "See Results"}
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-4">Quiz Complete!</h3>
              <p className="text-lg mb-4">
                Your Score: {mcqScore} out of {mcqQuestions.length}
              </p>
              <button
                onClick={resetMcq}
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Try Again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableDetails;